import React, {Fragment, Component } from 'react'
import store from '../store'

class Contact extends Component{
  constructor(props){
    super(props);
    this.state = store.getState();
    this.handleStoreChange = this.handleStoreChange.bind(this);
    store.subscribe(this.handleStoreChange);
  }
  render(){
    return(
      <Fragment>
        <div className='m1top center960'>
          <img className='m1img' src={this.state.contactad} alt='pictures' />
          <div className='contact0'>
            {this.state.contacts.map((item,index)=>{
              return <span className='contact1' key={index}>{item.topic}: {item.txt}</span>
            })}
           </div>
        </div>
  
      </Fragment>
    )
  }
  handleStoreChange() {
    this.setState(store.getState());
  }
}
export default Contact;